<div malihu-scrollbar class="h-100">
    <p class="d-block d-lg-none notes mb-0">Resources
      <a href="javascript:void(0)" (click)="onClose()" class="icon-close tabsClosed"></a>
    </p>
    <ul id="Resourceaccordion" class="contentAccordion courseAccordion">
      <ng-container *ngFor="let module of modules">
        <li *ngIf="isResourcesExists(module)" class="card">
          <div class="card-header" id="ResourceOne">
            <h5 class="mb-0">
              <button class="btn btn-link collapsed" data-bs-toggle="collapse"
                [attr.data-bs-target]="'#resourceOne' + module.moduleNumber" [attr.aria-expanded]="false"
                [attr.aria-controls]="'resourceOne' + module.moduleNumber">
                <span class="textLabel"><span class="number"></span>{{module?.moduleName}}</span>
                <i class="icon-arrow-down"></i>
              </button>
            </h5>
          </div>
          <div [attr.id]="'resourceOne' + module.moduleNumber" class="collapse" [class.show]="false"
            [attr.aria-labelledby]="'ResourceOne' +module.moduleNumber" data-bs-parent="#Resourceaccordion">
            <div class="card-body">
              <ul class="stepsCheck">
                <ng-container *ngFor="let content of module.contents">
                  <li class="success" *ngFor="let item of content.cards">
                    <a target="_blank" download href="{{item?.fileUrl}}" (click)="download(content)" class="lightColor">
                      <i class="icon-download leftmultiicons"></i> <span
                        class="text-label">{{item?.cardDescription}}</span>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
